export enum StoreState {
  PEDDING = "pedding",

  DONE = "done",

  ERROR = "error",

  SUCCESS = "success",
}
